import React from 'react';
import { LoadingSpinner } from '../core/LoadingSpinner';
import { Box, Button, Tab, Tabs, Typography } from '@mui/material';
import { MarketplaceTab } from './MarketplaceTab';
import { ActivExtensionTab } from './ActivExtensionTab';
import {
  useGetAppArray,
  useGetExtensions,
} from '../hooks/reactQuerys/AppQueries';
import CustomTabPanel from '../core/CustomTabPanel';
import { a11yProps } from '../services/dialog.service';

export const MarketplaceOverview: React.FC = () => {
  const { appArray, isLoadingAppArray } = useGetAppArray();
  const { extensionArray, isLoadingExtensionArray, refetchExtensionArray } =
    useGetExtensions();
  const [value, setValue] = React.useState(0);

  const extensionNotActiveArray =
    extensionArray === undefined || appArray === undefined
      ? []
      : extensionArray.filter(
          x => appArray.map(y => y.system_key).indexOf(x.system_key) === -1
        );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  if (isLoadingExtensionArray || isLoadingAppArray) {
    return <LoadingSpinner />;
  }

  if (!extensionArray || !appArray) {
    return (
      <Box sx={{ m: 2 }}>
        <Typography>
          Ein Fehler ist aufgetreten! Bitte versuchen Sie es später erneut.
          <Button onClick={() => refetchExtensionArray()}>
            Erneut versuchen
          </Button>
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h4'>Marktplatz</Typography>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='basic tabs example'
          >
            <Tab label='Marktplatz' {...a11yProps(0)} />
            <Tab label='Aktive Erweiterungen' {...a11yProps(1)} />
          </Tabs>
        </Box>

        <CustomTabPanel value={value} index={0}>
          <MarketplaceTab extensionArray={extensionNotActiveArray} />
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <ActivExtensionTab appArray={appArray} />
        </CustomTabPanel>
      </Box>
    </>
  );
};
